import { Helmet } from "react-helmet-async";

const SITE_NAME = "Tablify";
const SITE_URL = "https://tablify.hu";
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;

/**
 * Per-route <title>/description/canonical/OG/Twitter tags, plus optional
 * JSON-LD. Landing-only screens all share one static index.html otherwise,
 * so without this every marketing route (/, /about, /contact, ...) would
 * carry the exact same title and meta description.
 */
function Seo({ title, description, path = "/", image = DEFAULT_OG_IMAGE, jsonLd }) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const canonical = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="hu_HU" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}

export default Seo;
